import { BounceZoomIn, BounceZoomOut, FadeIn, FadeOut } from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import { CenterPivot, PIXIElement, Ungroup } from "slotworks/graphics/pixi/group";
import soundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contract";
import { parallel } from "slotworks/utils/race-utils";
import * as TweenJS from "slotworks/utils/tween";

const GLOWS = [
    "glow_1",
    "glow_2",
    "glow_3",
    "glow_4"
]

export default class BonusBuyTransitions extends AbstractSceneTransition {

    protected glowTweens: TweenJS.Tween<PIXIElement>[] = [];
    protected glowStack: PIXIElement[] = [];

    protected glowContainer: PIXIElement;

    public in(): Contract<void> {
        setTimeout(() => {
            soundManager.customEvent("bonusbuy")
        }, 1);
        return parallel([
            () => this.startStacks(),
            () => this.zoomIn(),
        ]);
    }

    public out(): Contract<void> {
        return new Contract<void>(resolve => {

            for (let tween of this.glowTweens) {
                tween.stop();
            }
            this.glowTweens.length = 0;

            soundManager.customEvent("plaque_exit"); 
            parallel([
                () => this.zoomOut(),
                () => this.stopStacks(),
                () => FadeOut(Layers.CelebrationBackground.getSprite("filter"), 200, 200)
            ]).then(resolve);
        })
    }

    protected zoomIn() {
        return BounceZoomIn(Layers.Prompts.container, 400, 80);
    }

    protected zoomOut() {
        return BounceZoomOut(Layers.Prompts.container, 400);
    }

    protected stopStacks() {
        return new Contract<void>(resolve => {

            new TweenJS.Tween(this.glowContainer.scale)
                .to({ x: 0, y: 0 }, 400)
                .onComplete(() => {
                    Ungroup(this.glowContainer);
                    resolve();
                })
                .start();
        });
    }

    protected startStacks() {
        return new Contract<void>(resolve => {
            // FadeIn(Layers.CelebrationBackground.getSprite("filter"), 200).execute();

            this.glowStack = [];
            this.glowTweens = [];

            soundManager.customEvent("bonus_buy_intro");

            for (let s of GLOWS) {
                this.glowStack.push(CenterPivot(Layers.CelebrationBackground.getSprite(s)));
            }

            this.glowContainer = CenterPivot(this.glowStack.slice().reverse());

            this.glowTweens.push(new TweenJS.Tween(this.glowStack[0])
                .to({ rotation: Math.PI * 2 }, 20000)
                .repeat(Infinity)
                .start());

            this.glowTweens.push(new TweenJS.Tween(
                CenterPivot(this.glowStack[1]))
                .to({ rotation: Math.PI * 2 }, 30000)
                .repeat(Infinity)
                .start());

            this.glowTweens.push(new TweenJS.Tween(
                this.glowStack[2])
                .to({ rotation: Math.PI * 2 }, 60000)
                .repeat(Infinity)
                .start());

            this.glowTweens.push(new TweenJS.Tween(
                this.glowStack[3])
                .to({ rotation: Math.PI * 2 }, 90000)
                .repeat(Infinity)
                .start());

            this.glowContainer.scale.set(0, 0);

            new TweenJS.Tween(this.glowContainer.scale)
                .to({ x: 2.2, y: 2.2 }, 400)
                .chain(
                    new TweenJS.Tween(this.glowContainer.scale)
                        .to({ x: 1.1, y: 1.1 }, 200)
                        .onComplete(() => { resolve(null) }))
                .start();
        });
    }
}